import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { InitialLoadingSpinnerService } from '@freelancer/pwa';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { UiConfig } from '@freelancer/ui/ui.interface';
import type { Observable } from 'rxjs';
import { ShellConfig } from './shell-config.service';
import type { LoggedOutShellConfig } from './shell-config.types';

// /!\ DO NOT ADD ANYTHING HERE WITHOUT ASKING FRONTEND INFRA FIRST /!\
// This code is loaded on ALL logged-out pages by default, and has to be manually disabled per page.
@Component({
  selector: 'app-logged-out-shell',
  template: `
    <fl-tracking-hotjar-init
      *ngIf="globalHotjar$ | flAsync"
    ></fl-tracking-hotjar-init>
    <ng-container *ngIf="!isEnterprise; else enterpriseNav">
      <app-navigation-logged-out-home
        *ngIf="!(config$ | flAsync)?.disableNavigation"
        [class.NavBackground]="(config$ | flAsync)?.enableDarkFixedNavigation"
        [containerSize]="(config$ | flAsync)?.containerSize"
        [containerSizeDesktopXLarge]="
          (config$ | flAsync)?.containerSizeDesktopXLarge
        "
        [useLoginSignupModal]="(config$ | flAsync)?.loginSignupModal"
        [disablePostProjectButton]="
          (config$ | flAsync)?.disablePostProjectButton
        "
        [navigationAlternate]="(config$ | flAsync)?.navigationAlternate"
      ></app-navigation-logged-out-home>
    </ng-container>
    <ng-template #enterpriseNav>
      <app-navigation-logged-out
        *ngIf="!(config$ | flAsync)?.disableNavigation"
        [containerSize]="(config$ | flAsync)?.containerSize"
        [containerSizeDesktopXLarge]="
          (config$ | flAsync)?.containerSizeDesktopXLarge
        "
        [useLoginSignupModal]="(config$ | flAsync)?.loginSignupModal"
        [disablePostProjectButton]="
          (config$ | flAsync)?.disablePostProjectButton
        "
        [navigationAlternate]="(config$ | flAsync)?.navigationAlternate"
      ></app-navigation-logged-out>
    </ng-template>
    <div
      [class.NavSpacing]="
        !isEnterprise &&
        !(config$ | flAsync)?.disableNavigation &&
        !(config$ | flAsync)?.enableDarkFixedNavigation
      "
    >
      <router-outlet></router-outlet>
    </div>
    <ng-container *flFeature="Feature.GIVE_GET">
      <app-give-get-footer
        *ngIf="!(config$ | flAsync)?.disableGiveGetFooter"
      ></app-give-get-footer>
    </ng-container>
    <app-footer
      *ngIf="!(config$ | flAsync)?.disableFooter"
      [containerSize]="(config$ | flAsync)?.containerSize"
    ></app-footer>
    <fl-file-download-alert></fl-file-download-alert>
  `,
  styleUrls: ['./logged-out-shell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoggedOutShellComponent implements OnInit {
  config$: Observable<LoggedOutShellConfig>;
  Feature = Feature;

  isEnterprise = false;
  globalHotjar$: Observable<boolean>;

  constructor(
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
    private initialLoadingSpinner: InitialLoadingSpinnerService,
    private shellConfig: ShellConfig,
    private activatedRoute: ActivatedRoute,
    private featureFlagsService: FeatureFlagsService,
  ) {}

  ngOnInit(): void {
    this.config$ = this.shellConfig.getConfig(this.activatedRoute);
    this.globalHotjar$ = this.featureFlagsService.getFlag(
      Feature.GLOBAL_HOTJAR,
    );

    // WARNING: this must not be removed, if it is, the app will show an infinite loading state.
    this.initialLoadingSpinner.removeLoadingSpinner();

    if (
      this.uiConfig.theme === 'deloitte' ||
      this.uiConfig.theme === 'freightlancer'
    ) {
      this.isEnterprise = true;
    }
  }
}
